module.exports = __webpack_public_path__ + "img/pc.10ba788e.png";